import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS2090_R01 } from "./Content_WMS2090_R01";
import { Info_WMS2090_R01 } from "./Info_WMS2090_R01";
import { useWMS2090_R01Store } from "./Store_WMS2090_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS2090_R01DetailDto, WMS2090_R01HeaderDto } from "./Dto_WMS2090_R01";
import SearchSection_WMS2090_R01 from "./SearchSection_WMS2090_R01";
import { Table_WMS2090_R01 } from "./Table_WMS2090_R01";
import { DetailTable_WMS2090_R01 } from "./DetailTable_WMS2090_R01";


export const Container_WMS2090_R01 = () => {

	const { 
		syncInitialData,
		WMS2090_R01List,
		WMS2090_R01DetailList,
	} = useWMS2090_R01Store();

	
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'WMS2090_R01',
		type: 'width',
		storageKey: 'WMS2090_R01-split-width',
		min: 5,
		max: 80,
		default: 27
	} as const;
	const gridRef = useRef<AgGridReact<WMS2090_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS2090_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'WMS2090_R01',
		type: 'height',
		storageKey: 'WMS2090_R01-info-split-height',
		min: 5,
		max: 80,
		default: 30
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		clickable, setClickable,
		handleExcelClick,
		fetchData,
		defaultWMS2090_R01HeaderRow,
		defaultWMS2090_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleInsertClick,
		handleSaveClick,
	} = Content_WMS2090_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	useEffect(() => {
		if (WMS2090_R01List.length === 0 && WMS2090_R01DetailList.length === 0) {
			syncInitialData();
			handleCreateClick();
		}
	}, [WMS2090_R01List, WMS2090_R01DetailList, syncInitialData, handleCreateClick]);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS2090_R01 />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS2090_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultWMS2090_R01HeaderRow={defaultWMS2090_R01HeaderRow()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_WMS2090_R01 
						editable={true}
						defaultWMS2090_R01HeaderRow={defaultWMS2090_R01HeaderRow()}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }} className="pb-[12px]">
					<DetailTable_WMS2090_R01 
						gridRef={detailGridRef} 
						defaultWMS2090_R01DetailRow={defaultWMS2090_R01DetailRow()}
						clickable={clickable}
						setClickable={setClickable}
						handleInsertClick={handleInsertClick}
					/>
				</div>
			</div>
		</div>
		<Message />
	</div>
}

